var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "b-row",
        [_c("b-col", { staticClass: "hr", attrs: { cols: "12" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                { staticClass: "border" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "head", attrs: { cols: "12" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c("h4", [_vm._v(":: Clientes")])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                {
                                  staticClass: "mt-2 border-top border-bottom"
                                },
                                [
                                  _c("b-col", {
                                    staticClass: "pt-3",
                                    attrs: { cols: "6" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "pt-3 text-right",
                                      attrs: { cols: "6" }
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "datepicker-trigger" },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "f_name",
                                                  horizontal: "",
                                                  "label-cols": 2,
                                                  breakpoint: "md",
                                                  label: "Fecha:"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "datepicker-trigger",
                                                    state: _vm.state,
                                                    value: _vm.formatDates(
                                                      _vm.dateOne,
                                                      _vm.dateTwo
                                                    ),
                                                    placeholder:
                                                      "Seleccione fecha"
                                                  },
                                                  model: {
                                                    value: _vm.dates.date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.dates,
                                                        "date",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "dates.date"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("AirbnbStyleDatepicker", {
                                              attrs: {
                                                "trigger-element-id":
                                                  "datepicker-trigger",
                                                mode: "range",
                                                "fullscreen-mobile": true,
                                                "date-one": _vm.dateOne,
                                                "date-two": _vm.dateTwo
                                              },
                                              on: {
                                                "date-one-selected": function(
                                                  val
                                                ) {
                                                  _vm.dateOne = val
                                                },
                                                "date-two-selected": function(
                                                  val
                                                ) {
                                                  _vm.dateTwo = val
                                                },
                                                apply: _vm.apply
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "breadcrumb",
                              attrs: { cols: "12" }
                            },
                            [
                              _c(
                                "b-link",
                                { attrs: { to: { name: "SupervisorIndex" } } },
                                [_vm._v("Clientes")]
                              ),
                              _vm._v(
                                " » Lista de clientes de " +
                                  _vm._s(this.$route.params.brand) +
                                  ":"
                              ),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "float-right",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.descargar_csv.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Descargar Lista")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (this.dates.date1 === this.today &&
                                      this.dates.date2 === this.today &&
                                      this.dates.date2 < this.today) ||
                                    this.dates.date1 === this.dates.date2,
                                  expression:
                                    "(this.dates.date1 === this.today && this.dates.date2 === this.today && this.dates.date2<this.today) || (this.dates.date1===this.dates.date2)"
                                }
                              ]
                            },
                            [
                              _vm._v("Mostrando registros del "),
                              _c("strong", [_vm._v(_vm._s(this.skip))]),
                              _vm._v(" al "),
                              _c("strong", [
                                _vm._v(_vm._s(parseInt(this.skip + this.len)))
                              ]),
                              _vm._v(" de un total de "),
                              _c("strong", [_vm._v(_vm._s(this.count))]),
                              _vm._v(" pertenecientes al "),
                              _c("strong", [_vm._v(_vm._s(this.today))]),
                              _vm._v(":")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    this.dates.date1 != "" &&
                                    this.dates.date1 != this.dates.date2,
                                  expression:
                                    "this.dates.date1 != '' && this.dates.date1 != this.dates.date2"
                                }
                              ]
                            },
                            [
                              _vm._v("Registros pertenecientes del "),
                              _c("strong", [_vm._v(_vm._s(this.skip))]),
                              _vm._v(" al "),
                              _c("strong", [
                                _vm._v(_vm._s(parseInt(this.skip + this.len)))
                              ]),
                              _vm._v(" de un total de "),
                              _c("strong", [_vm._v(_vm._s(this.count))]),
                              _vm._v(" desde el "),
                              _c("strong", [_vm._v(_vm._s(this.dates.date1))]),
                              _vm._v(" al "),
                              _c("strong", [_vm._v(_vm._s(this.dates.date2))]),
                              _vm._v(":")
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3" }),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          items: _vm.clients,
                          fields: _vm.fields
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.details(row.item)
                                      }
                                    }
                                  },
                                  [_vm._v("Ver detalle")]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-pagination-nav", {
                        attrs: {
                          "link-gen": _vm.linkGen,
                          align: "center",
                          "number-of-pages": _vm.pages_nav,
                          value: _vm.currentPage
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    this.dates.date1 === this.today ||
                                    this.dates.date2 === this.today,
                                  expression:
                                    "this.dates.date1 === this.today || this.dates.date2 === this.today"
                                }
                              ]
                            },
                            [
                              _vm._v("Mostrando registros del "),
                              _c("strong", [_vm._v(_vm._s(this.skip))]),
                              _vm._v(" al "),
                              _c("strong", [
                                _vm._v(_vm._s(parseInt(this.skip + this.len)))
                              ]),
                              _vm._v(" de un total de "),
                              _c("strong", [_vm._v(_vm._s(this.count))]),
                              _vm._v(" pertenecientes al "),
                              _c("strong", [_vm._v(_vm._s(this.today))]),
                              _vm._v(":")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    this.dates.date1 != "" &&
                                    this.dates.date1 != this.dates.date2,
                                  expression:
                                    "this.dates.date1 != '' && this.dates.date1 != this.dates.date2"
                                }
                              ]
                            },
                            [
                              _vm._v("Registros pertenecientes del "),
                              _c("strong", [_vm._v(_vm._s(this.skip))]),
                              _vm._v(" al "),
                              _c("strong", [
                                _vm._v(_vm._s(parseInt(this.skip + this.len)))
                              ]),
                              _vm._v(" de un total de "),
                              _c("strong", [_vm._v(_vm._s(this.count))]),
                              _vm._v(" desde el "),
                              _c("strong", [_vm._v(_vm._s(this.dates.date1))]),
                              _vm._v(" al "),
                              _c("strong", [_vm._v(_vm._s(this.dates.date2))]),
                              _vm._v(":")
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.errors && _vm.errors.length
                        ? _c(
                            "ul",
                            _vm._l(_vm.errors, function(error, index) {
                              return _c(
                                "li",
                                { key: index },
                                [
                                  _c("b-alert", { attrs: { show: "" } }, [
                                    _vm._v(_vm._s(error.message))
                                  ])
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54c7abd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c7abd3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supervisor/ClientListByBrands.vue
// module id = null
// module chunks = 